<template>
  <modal name="eventModal" class="event-modal" :height="calculateHeight" :class="{'v--modal-box v--modal':isChangeOrder, 'modal-delete' : isDeleteModal}" :width="700" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="modal-header">
      <div class="modal-header-text">
        <span>{{ modalData.title }}</span>
      </div>
      <!-- <div class="line"></div> -->
    </div>
    <div class="modal-body">
      <SuggestChanges v-if="(modalData.modalAction == actionTypes.suggestChanges || modalData.modalAction == actionTypes.reviewSuggestChanges)"></SuggestChanges>
      <ChangeSubmitted v-if="modalData.modalAction == actionTypes.showInfo"></ChangeSubmitted>
      <SubmitEventModal v-if="(modalData.modalAction == actionTypes.submitEvent || modalData.modalAction == actionTypes.reviewResubmit)" :itemName="actionData.eventName"></SubmitEventModal>
      <ChangeOrder v-if="(modalData.modalAction == actionTypes.changeOrder)" :itemName="actionData.eventName"></ChangeOrder>
      <ApproveEvent v-if="(modalData.modalAction == actionTypes.approveEvent)"></ApproveEvent>
      <DeleteEvent v-if="(modalData.modalAction == actionTypes.deleteEvent)" ></DeleteEvent>
      <SubmitAllEventEmptyFieldsError v-if="modalData.modalAction == actionTypes.someEmptyFields"></SubmitAllEventEmptyFieldsError>
      <SubmitAllEvent90DaysError v-if="modalData.modalAction == actionTypes.lessThan90Days"></SubmitAllEvent90DaysError>
      <SubmitAllEventEmptyFieldsAnd90DaysError v-if="modalData.modalAction == actionTypes.someEmptyFieldsOrLessThan90Days"></SubmitAllEventEmptyFieldsAnd90DaysError>
      <EventTimeInvalid v-if="modalData.modalAction == actionTypes.eventPrefDateInvalid"></EventTimeInvalid>
      <ModalInfoBody v-if="modalData.modalAction == actionTypes.eventNameNotUnique || modalData.modalAction == actionTypes.someFieldsBlank || modalData.modalAction == actionTypes.eventDurationRestricted || modalData.modalAction == actionTypes.readOnly || modalData.modalAction == actionTypes.deleteUser || modalData.modalAction == actionTypes.deleteValidator || modalData.modalAction == actionTypes.emailIsNotValid || modalData.modalAction == actionTypes.deleteClient" :messages="bodyMessage"></ModalInfoBody>
      <ModalBodyWithErrorCodes v-if="modalData.modalAction == actionTypes.submitAllError" :messages="bodyMessageWithErrorCode"></ModalBodyWithErrorCodes>
      <AddClient v-if="modalData.modalAction == actionTypes.addClient" :clientInfo="clientInfo" v-on:disableBtnRight="setDisableButtonRight"></AddClient>
      <UserInfo v-if="modalData.modalAction == actionTypes.createUser || modalData.modalAction == actionTypes.editUser" :modalAction="modalData.modalAction" :userInfo="actionData" :modalDataValid="modalDataValid"></UserInfo>
      <ResetPasswordModal v-if="modalData.modalAction == actionTypes.resetPassword" :resetPasswordInfo="resetPasswordInfo" v-on:disableBtnRight="setDisableButtonRight"></ResetPasswordModal>
      <MoveEvent v-if="(modalData.modalAction == actionTypes.moveEvent)"
                 :moveEventData="moveEventData"></MoveEvent>
      <ForceUserResetPassword :userId="userId" v-if="(modalData.modalAction == actionTypes.forceUserResetPassword)"></ForceUserResetPassword>
      <AddValidator v-if="modalData.modalAction == actionTypes.createValidator || modalData.modalAction == actionTypes.editValidator" :validatorInfo="validatorInfo"></AddValidator>
    </div>
    <div class="modal-footer">
      <b-button v-if="modalData.btnLeft != ''" class="modal-btn-left ap-btn secondary" @click="hideModal()" >
        {{ modalData.btnLeft }}
      </b-button>
      <b-button v-if="modalData.btnRight != ''" class="modal-btn-right ap-btn primary" @click="btnAction()" :disabled="disableButtonRight">
        {{ modalData.btnRight }}
      </b-button>
    </div>
  </modal>
</template>
<script>
import Vue from 'vue';
import AddClient from './AddClientModal';
import ResetPasswordModal from './ResetPasswordModal';
import SuggestChanges from './SuggestChanges';
import ChangeOrder from './ChangeOrder';
import ChangeSubmitted from './ChangeSubmitted';
import SubmitEventModal from './SubmitEventModal';
import ApproveEvent from './ApproveEvent';
import DeleteEvent from './DeleteEvent';
import SubmitAllEventEmptyFieldsError from './SubmitAllEventEmptyFieldsError';
import SubmitAllEvent90DaysError from './SubmitAllEvent90DaysError';
import SubmitAllEventEmptyFieldsAnd90DaysError from './SubmitAllEventEmptyFieldsAnd90DaysError';
import EventTimeInvalid from './EventTimeInvalid';
import ModalBodyWithErrorCodes from './ModalBodyWithErrorCodes';
import UserInfo from './UserInfo';
import ModalInfoBody from './ModalInfoBody';
import ForceUserResetPassword from './ForceUserResetPassword';
import AddValidator from './globalSettings/AddValidator';
import consts from '../../_consts';
import { mapActions } from 'vuex';
import MoveEvent from './MoveEvent';
const _ = require('lodash');

export default {
  name: '',
  components: {
    SuggestChanges, // belong with submitted
    ChangeOrder, // belong  with approved
    ChangeSubmitted,
    SubmitEventModal, // belong with drafts
    ApproveEvent,
    DeleteEvent,
    SubmitAllEventEmptyFieldsError,
    EventTimeInvalid,
    ModalInfoBody,
    SubmitAllEvent90DaysError,
    SubmitAllEventEmptyFieldsAnd90DaysError,
    ModalBodyWithErrorCodes,
    AddClient,
    UserInfo,
    ResetPasswordModal,
    MoveEvent,
    ForceUserResetPassword,
    AddValidator
  },
  data () {
    return {
      actionTypes: consts.modalAction,
      modalData: {},
      actionData: {},
      isCancel: false,
      modalBodies: consts.modalBodies,
      clientInfo: {
        clientName: '',
        firstName: '',
        lastName: '',
        email: '',
        errorMessage: ''
      },
      resetPasswordInfo: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        userId: null
      },
      dataBackup: null,
      disableButtonRight: false,
      moveEventData: {
        eventId: '',
        eventName: '',
        updateStatus: ''
      },
      modalDataValid: true,
      userId: '',
      validatorInfo: {},
      callback: null
    }
  },
  methods: {
    hideModal () {
      this.clientInfo = {
        clientName: '',
        firstName: '',
        lastName: '',
        email: '',
        errorMessage: '',
        isDisable: false
      };
      this.resetPasswordInfo = {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        userId: null
      };
      this.isCancel = true;
      this.$modal.hide('eventModal');
      this.disableButtonRight = false;
    },
    beforeOpen (event) {
      console.log('modal', event.params);
      this.modalData = consts.mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
      this.callback = event.params.callback;
      this.dataBackup = _.cloneDeep(event.params.data);
      if (event.params.action === this.actionTypes.createUser) {
        this.actionData = {
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          client: null,
          role: ''
        }
      }
      if (event.params.action === this.actionTypes.moveEvent) {
        this.moveEventData = event.params.data;
      }
      if (event.params.action === this.actionTypes.forceUserResetPassword) {
        this.userId = this.actionData.id;
      }
      if (event.params.action === this.actionTypes.addClient) {
        this.clientInfo = {
          clientName: '',
          firstName: '',
          lastName: '',
          email: '',
          errorMessage: ''
        }
      }
      if (event.params.action === this.actionTypes.createValidator) {
        this.validatorInfo = {
          name: '',
          field: ''
        }
      }
      if (event.params.action === this.actionTypes.editValidator) {
        this.validatorInfo = event.params.data;
      }
    },
    async btnAction () {
      let modalData = this.modalData;
      let actionTypes = consts.modalAction;
      // submit event => event move to Submitted folder
      if (this.modalData.modalAction === consts.modalAction.submitEvent) {
        if (this.actionData.id === null || this.actionData.id === undefined) {
          // submit all event
          this.submitAllEvent();
        } else {
          let role = localStorage.getItem(consts.LOCAL_STORE.role);
          if (role === consts.USER_ROLE.eventManager || role === consts.USER_ROLE.admin) {
            let event = _.cloneDeep(this.actionData);
            event.isChangeOrder = false;
            this.approveEvent(event);
          }
          // else {
          //   let event = _.cloneDeep(this.actionData);
          //   event.status = consts.eventStatus.submitted.toUpperCase();
          //   this.submitEvent(event);
          // }
        }
      }
      // delete event
      if (this.modalData.modalAction === consts.modalAction.deleteEvent) {
        this.callback ? this.callback() : this.deleteEvent(this.actionData);
      }
      // change order => event move from Approved to Drafts
      if (this.modalData.modalAction === consts.modalAction.changeOrder) {
        let event = {};
        if (this.actionData.eventDetail) {
          event = _.cloneDeep(this.actionData.eventDetail);
        } else {
          event = _.cloneDeep(this.actionData);
        }
        let data = {
          action: consts.modalAction.changeOrderDetail,
          data: event
        };
        this.$modal.show('ModalChangeOrder', data);
      }
      // false => close Modal, true => stay in modal
      let isClosedModal = false;
      // add client
      if (this.modalData.modalAction === consts.modalAction.addClient) {
        // this.addClient(this.clientInfo);
        await this.addClient(this.clientInfo).then((response) => {
          if (response && response.message) {
            Vue.prototype.$toastr('error', response.message ? response.message : 'Unsuccessfully adding new client', '');
            isClosedModal = true;
          } else {
            Vue.prototype.$toastr('info', 'Successfully adding new client', '');
            isClosedModal = false;
          }
          this.setMessageError('');
        });
      }
      // Create user
      if (this.modalData.modalAction === consts.modalAction.createUser) {
        await this.$children[0].$children[0].validateData().then(() => {
          if (!this.actionData.modalDataValid) {
            isClosedModal = true;
            return;
          }
          this.actionData.client = {
            id: this.actionData.clientId,
            clientName: this.actionData.clientName
          };
          this.createUser(this.actionData);
          isClosedModal = false;
        });
      }
      // Edit user
      if (this.modalData.modalAction === consts.modalAction.editUser) {
        await this.$children[0].$children[0].validateData().then(() => {
          if (!this.actionData.modalDataValid) {
            isClosedModal = true;
            return;
          }
          let data = this.actionData;
          let body = {
            id: data.id,
            firstName: data.firstName,
            lastName: data.lastName,
            role: data.role,
            phoneNumber: data.phoneNumber,
            email: data.email,
            client: {
              id: data.role === consts.USER_ROLE.client ? data.client.id : 0,
              clientName: data.role === consts.USER_ROLE.client ? data.client.clientName : ''
            }
          };
          this.editUser(body);
          isClosedModal = false;
        });
      }

      // create validator
      if (this.modalData.modalAction === consts.modalAction.createValidator) {
        let data = this.validatorInfo;
        let body = {
          name: data.name,
          field: data.field
        };
        this.createValidator(body).then(response => {
          if (response.message === null) {
            this.getAllValidatorAfterUpdateOrCreate();
          }
        });
      }

      // update validator
      if (this.modalData.modalAction === consts.modalAction.editValidator) {
        let data = this.actionData;
        let body = {
          id: data.id,
          name: data.name,
          field: data.field
        };
        this.updateValidator(body).then(response => {
          if (response.message === null) {
            this.getAllValidatorAfterUpdateOrCreate();
          }
        });
      }

      // delete validator
      if (this.modalData.modalAction === consts.modalAction.deleteValidator) {
        let data = this.actionData;
        this.deleteValidator(data.id).then(response => {
          if (response.message === null) {
            this.getAllValidatorAfterUpdateOrCreate();
          }
        });
      }

      // move event
      if (this.modalData.modalAction === consts.modalAction.moveEvent) {
        this.moveEvent({eventId: this.moveEventData.eventId, status: this.moveEventData.updateStatus.toUpperCase()});
      }

      // delete user
      if (modalData.modalAction === actionTypes.deleteUser) {
        this.deleteUser({id: this.actionData.id}).then(response => {
          Vue.prototype.$toastr('success', 'Delete user successfully', '');
        }, () => { Vue.prototype.$toastr('error', 'Internal server error.', ''); });
      }

      // EM or Admin forces user to reset password
      if (this.modalData.modalAction === consts.modalAction.forceUserResetPassword) {
        this.forceResetPassword(this.userId);
      }

      // Delete Client
      if (this.modalData.modalAction === consts.modalAction.deleteClient) {
        let body = {
          id: this.actionData.id
        };
        this.deleteClient(body).then((response) => {
          this.$toast.success(`Client ${this.actionData.clientName} has been deleted.`, '', {
            ...this.$toastOpt.optSuccess
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }).catch(() => {
          this.$toast.success(`Can not delete client ${this.actionData.clientName}`, '', {
            ...this.$toastOpt.optError
          });
        });
      }

      // Reset password
      if (this.modalData.modalAction === consts.modalAction.resetPassword) {
        this.resetPassword(this.resetPasswordInfo).then((response) => {
          if (response && response.message) {
            Vue.prototype.$toastr('error', response.message, '');
            isClosedModal = true;
          } else {
            Vue.prototype.$toastr('success', 'Change password successful', '');
            isClosedModal = false;
          }
          this.setMessageError('');
          if (!isClosedModal) {
            this.$modal.hide('eventModal');
          }
        });
      } else {
        this.isCancel = false;
        if (this.modalData.modalAction !== this.actionTypes.eventDurationRestricted) {
          this.setExpandId({id: -1, isExpand: false});
        }
        this.setMessageError('');
        if (!isClosedModal) {
          this.$modal.hide('eventModal');
        }
      }
    },
    ...mapActions({
      addClient: 'ACTION_ADD_CLIENT',
      submitEvent: 'ACTION_SUBMIT_EVENT',
      approveEvent: 'ACTION_APPROVE_EVENT',
      suggestChanges: 'ACTION_SUGGEST_CHANGES',
      deleteEvent: 'ACTION_DELETE_EVENT',
      submitAllEvent: 'ACTION_SUBMIT_ALL_EVENT',
      setExpandId: 'ACTION_SET_EXPAND_ID',
      setMessageError: 'ACTION_SET_MESSAGE_ERROR',
      createUser: 'ACTION_CREATE_USER',
      editUser: 'ACTION_EDIT_USER',
      resetPassword: 'ACTION_CHANGE_PASSWORD',
      moveEvent: 'ACTION_CHANGE_EVENT_STATUS',
      deleteUser: 'ACTION_ACTION_DELETE_USER',
      forceResetPassword: 'ACTION_FORCE_RESET_PASSWORD',
      createValidator: 'ACTION_CREATE_VALIDATOR',
      updateValidator: 'ACTION_UPDATE_VALIDATOR',
      getAllValidatorAfterUpdateOrCreate: 'ACTION_GET_ALL_VALIDATORS',
      deleteValidator: 'ACTION_DELETE_VALIDATOR',
      deleteClient: 'ACTION_DELETE_CLIENT'
    }),
    beforeClose () {
      let data = this.dataBackup;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.actionData[key] = data[key];
        }
      }
    },
    setDisableButtonRight (isDisable) {
      this.disableButtonRight = isDisable;
    }
  },
  computed: {
    calculateHeight () {
      if (this.modalData.modalAction === this.actionTypes.deleteEvent) {
        return 290;
      }
      return 'auto';
    },
    isChangeOrder () {
      return this.modalData.modalAction === this.actionTypes.changeOrder;
    },
    isDeleteModal () {
      return this.modalData.modalAction === this.actionTypes.deleteEvent;
    },
    showModalBodyMessage () {
    },
    bodyMessage () {
      let actionTypes = this.actionTypes;
      let modalData = this.modalData;
      let modalBodies = this.modalBodies;
      if (modalData.modalAction === actionTypes.eventNameNotUnique) {
        return modalBodies.eventNameNotUnique;
      }
      if (modalData.modalAction === actionTypes.someFieldsBlank) {
        return modalBodies.someFieldsBlank;
      }
      if (modalData.modalAction === actionTypes.eventDurationRestricted) {
        return modalBodies.eventDurationRestricted;
      }
      if (modalData.modalAction === actionTypes.readOnly) {
        return modalBodies.readOnly;
      }
      if (modalData.modalAction === actionTypes.deleteUser) {
        return modalBodies.deleteUser;
      }
      if (modalData.modalAction === actionTypes.deleteValidator) {
        return modalBodies.deleteValidator;
      }
      if (modalData.modalAction === actionTypes.emailIsNotValid) {
        return modalBodies.emailIsNotValid;
      }
      if (modalData.modalAction === actionTypes.deleteClient) {
        let result = _.cloneDeep(modalBodies.deleteClient);
        result[0] = result[0].replace('{clientName}', this.actionData.clientName);
        return result;
      }
    },
    bodyMessageWithErrorCode () {
      let messages = [];
      let data = this.actionData;
      for (let prop in data) {
        if (data[prop]) {
          let temp = consts.modalBodies[prop][0];
          messages.push(temp);
        }
      }
      return messages;
    }
  }
}
</script>

<style lang="less">
@import '../../styles/variables.less';

.event-modal {
  &.modal-change-order-detail {
    .v--modal-box {
      overflow-y: scroll;
    }
  }
  margin: 0;
  background: rgba(0, 0, 0, 0.4);

  .modal-header {
    padding: 0;
    border: 0;
    border-bottom: 1px solid #c2cfd6;
    width: 85%;
    margin: 0 auto;

    .line{
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid #E6E6E6;
    }
    .modal-header-text {
      margin-top: 50px;
      height: 29px;
      // width: auto;
      color: @black;
      font-family: @font-family-title;
      font-size: 24px;
      font-weight: bold;
      line-height: 29px;
      text-transform: uppercase;
    }
    .modal-header-change-order-text{
      margin-top: 25px;
      margin-left: 25px;
      height: 29px;
      width: auto;
      color: @black;
      font-family: @font-family-title;
      font-size: 24px;
      font-weight: bold;
      line-height: 29px;
      text-transform: uppercase;
    }
    .modal-header-line{
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid @grey-4;
    }
  }
  .modal-body {
    height: auto;
    width: 85%;
    margin: 0 auto;
    padding: 20px 0 0 0;

    .modal-body-text {
      color: #424242;
      font-family: @font-family-main;
      font-size: 16px;
      line-height: 24px;
    }
    .modal-body-text-li {
      margin-top: 20px;
    }
  }
  .modal-body-changeOrderDetail{
    .modal-body-changeOrderDetail-text{
      margin-top: 25px;
      margin-left: 25px;
      color: @black;
      font-family: @font-family-main;
      font-size: 14px;
      line-height: 14px;
    }
    .modal-body-changeOrderDetail-event-detail{
      margin: 26px 0 0 0;
    }
  }
  .modal-footer {
    /*position: absolute;*/
    bottom: 0;
    right: 0;
    padding: 0;
    float: right;
    border: 0;
    .modal-btn-left {
      border-radius: 4px;
      margin-left: 15px;
      margin-bottom: 50px;
      margin-top: 30px;
      .modal-btn-left-text {
        color: @light-blue;
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
      }
    }
    .modal-btn-right {
      border-radius: 4px;
      margin-right: 50px;
      margin-bottom: 50px;
      margin-top: 30px;
      .modal-btn-right-text {
        color: @white;
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?38518b23